import { render } from "./teaZcEcharts.vue?vue&type=template&id=94a6c0bc&scoped=true"
import script from "./teaZcEcharts.vue?vue&type=script&lang=js"
export * from "./teaZcEcharts.vue?vue&type=script&lang=js"

import "./teaZcEcharts.vue?vue&type=style&index=0&id=94a6c0bc&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94a6c0bc"]])

export default __exports__